import{defineMessages}from'react-intl';

export default defineMessages({
label_district:{
id:'i18n.event_list_page.label_district',
defaultMessage:'District'},

label_region:{
id:'i18n.event_list_page.label_region',
defaultMessage:'Region'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0V2ZW50U3RvcmVEZXRhaWxzL0V2ZW50U3RvcmVEZXRhaWxzLm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwibGFiZWxfZGlzdHJpY3QiLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwibGFiZWxfcmVnaW9uIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFTQSxjQUFULEtBQStCLFlBQS9COztBQUVBLGNBQWVBLGdCQUFlO0FBQzVCQyxlQUFnQjtBQUNkQyxHQUFJLHFDQURVO0FBRWRDLGVBQWdCLFVBRkYsQ0FEWTs7QUFLNUJDLGFBQWM7QUFDWkYsR0FBSSxtQ0FEUTtBQUVaQyxlQUFnQixRQUZKLENBTGMsQ0FBZixDQUFmIiwiZmlsZSI6IkV2ZW50U3RvcmVEZXRhaWxzLm1lc3NhZ2VzLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBkZWZpbmVNZXNzYWdlcyB9IGZyb20gJ3JlYWN0LWludGwnO1xuXG5leHBvcnQgZGVmYXVsdCBkZWZpbmVNZXNzYWdlcyh7XG4gIGxhYmVsX2Rpc3RyaWN0OiB7XG4gICAgaWQ6ICdpMThuLmV2ZW50X2xpc3RfcGFnZS5sYWJlbF9kaXN0cmljdCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdEaXN0cmljdCcsXG4gIH0sXG4gIGxhYmVsX3JlZ2lvbjoge1xuICAgIGlkOiAnaTE4bi5ldmVudF9saXN0X3BhZ2UubGFiZWxfcmVnaW9uJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1JlZ2lvbicsXG4gIH0sXG59KTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/components/EventStoreDetails/EventStoreDetails.messages.js
// module id = 2108
// module chunks = 0